/**
 * The switch on the assets header ("موجودی اندک", screens 18 and 34).
 *
 * 48×28 on a radius-16 track with a 20px knob and 4px inset. The design draws
 * only the on state, with the knob on the left — which is what the logical
 * end is in RTL, so the knob mirrors with the writing direction rather than
 * being pinned to a physical side.
 */
interface ToggleProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label: string
  disabled?: boolean
}

export function Toggle({ checked, onChange, label, disabled }: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={[
        'flex h-7 w-12 shrink-0 items-center rounded-16 p-1 transition-colors duration-(--sx-dur)',
        checked ? 'justify-end bg-primary' : 'justify-start bg-surface-10',
        'disabled:opacity-50',
      ].join(' ')}
    >
      <span className="size-5 rounded-full bg-white" />
    </button>
  )
}
